export default class Lock {
    constructor() {
        this.lock = 0;
        this.waitingLocks = [];
    }
    async acquireLock() {
        if (this.lock === 0) {
            this.lock = Date.now();
            return Promise.resolve();
        }
        return new Promise((resolve) => {
            this.waitingLocks.push(resolve);
        });
    }
    releaseLock() {
        this.lock = 0;
        if (this.waitingLocks.length > 0) {
            const lastResolve = this.waitingLocks.shift();
            if (typeof lastResolve !== 'undefined') {
                this.lock = Date.now();
                lastResolve();
            }
        }
    }
}
